// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"658":"c7c9310a","835":"094fb649"}[chunkId] + ".chunk.js";
};